/* eslint-disable */

import React, { useState, useEffect } from "react";
import Unity, { UnityContext } from "react-unity-webgl";
import styles from "./unityComponentMap.css";
import {
  UNITY_MAP_BASE_PATH,
  UNITY_MAP_VERSION,
} from "../../../utils/constants";
import Spinner from "../spinner/spinner";
import { ENVIRONMENTUNITY } from "../../../utils/constants";

const unityContext = new UnityContext({
  productName: "React Unity WebGL Coderblock",
  companyName: "Coderblock",
  loaderUrl: `${UNITY_MAP_BASE_PATH}Build/Season1_0.0.1_br.loader.js?v=${UNITY_MAP_VERSION}`,
  dataUrl: `${UNITY_MAP_BASE_PATH}Build/Season1_0.0.1_br.data.br?v=${UNITY_MAP_VERSION}`,
  frameworkUrl: `${UNITY_MAP_BASE_PATH}Build/Season1_0.0.1_br.framework.js.br?v=${UNITY_MAP_VERSION}`,
  codeUrl: `${UNITY_MAP_BASE_PATH}Build/Season1_0.0.1_br.wasm.br?v=${UNITY_MAP_VERSION}`,
  streamingAssetsUrl: `${UNITY_MAP_BASE_PATH}StreamingAssets?v=${UNITY_MAP_VERSION}`,
  // Additional configuration options.
  webglContextAttributes: {
    preserveDrawingBuffer: true,
  },
});

function UnityComponentMap(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [progression, setProgression] = useState(0);
  const [firstUnitySend, setFirstUnitySend] = useState(false);

  useEffect(() => {
    props.setSelectLand([]);
    unityContext.on("progress", handleOnUnityProgress);
    unityContext.on("loaded", handleOnUnityLoaded);
    unityContext.on("handleSingleSelectLand", handleSingleSelectLand);
    return function () {
      unityContext.removeAllEventListeners();
      unityContext.quitUnityInstance();
    };
  }, []);

  function handleOnUnityProgress(progression) {
    setProgression(progression);
  }

  function handleSingleSelectLand(ourPositionLand) {
    let jsonArray = JSON.parse(ourPositionLand);
    // console.log("jsonArray", jsonArray);
    let filteredArray = jsonArray.filter(item => item.x !== '0' && item.y !== '0');
    // console.log("filteredArray", filteredArray);
    props.setSelectLand(filteredArray);
  }

  function handleOnUnityLoaded() {
    setIsLoaded(true);
  }

  if (progression === 1 && isLoaded && firstUnitySend === false) {
    setTimeout(() => {
      setFirstUnitySend(true);
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      unityContext.send("Connect", "SetUseMobileDevice", isMobile.toString());
      unityContext.send("Connect", "SetEnvironment", ENVIRONMENTUNITY);
    }, 1000);
  }

  return (
    <>
      {isLoaded === false && (
        <div className={styles.loading_overlay}>
          <div className={styles.progress_bar}>
            <div
              className={styles.progress_bar_fill}
              style={{ width: progression * 100 + "%" }}
            />
          </div>
        </div>
      )}
      <div
        className={styles.unity_canvas_container}
        style={{ display: "flex", justifyContent: "center" }}
      >
        {progression === 1 && isLoaded ? null : (
          <div style={{ marginTop: "150px" }}>
            <Spinner />
          </div>
        )}
        <Unity
          unityContext={unityContext}
          style={{
            width: isLoaded ? "100%" : "0px",
            marginLeft: 5,
            marginRight: 5,
            borderRadius: "5px",
            overflow: "hidden",
            height: "600px",
            maxHeight: "600px",
            maxWidth: "1280px",
          }}
          className={
            isLoaded ? styles.unity_canvas__loaded : styles.unity_canvas
          }
        />
      </div>
    </>
  );
}

export default UnityComponentMap;
